// extracted by mini-css-extract-plugin
module.exports = {"pressNews":"PressNews_pressNews__6DTEl","content":"PressNews_content__WZOiT","newsList":"PressNews_newsList__y31pr"};